import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { clearAuthSession, fetchMe, setAuthSession } from './api';

function ProtectedRoute({ children }) {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const me = await fetchMe();
        if (!cancelled) {
          setAuthSession(me);
          setStatus('ok');
        }
      } catch {
        clearAuthSession();
        if (!cancelled) setStatus('deny');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-600">
        Vérification de session…
      </div>
    );
  }

  if (status === 'deny') {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}

export default ProtectedRoute;
